import CONST_DATA from "./constData"

export default {
  data() {
    return {
      CONST_DATA,
    }
  }
}